/**
 * Create a string where each space-delimited substring has one capital letter at index zero
 * @param {String} s - A string
 * @return {String} - a string turned to title case
 */
export default function toTitleCase(s: string): string {
  return s.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
};